import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPersonLock24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconPersonLock24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.4 8h-1.5a2.5 2.5 0 1 0-3.3 2.37v1.595A4.9 4.9 0 0 0 5.5 16.8v1.7h4.1V20H4v-3.2a6.4 6.4 0 0 1 3.732-5.82A4 4 0 1 1 14.4 8M12 12.346V12a3.2 3.2 0 0 1 6.4 0v.346A3 3 0 0 1 20 15v2a3 3 0 0 1-3 3h-3.6a3 3 0 0 1-3-3v-2a3 3 0 0 1 1.6-2.654m.86 1.254a1.5 1.5 0 0 0-.96 1.4v2a1.5 1.5 0 0 0 1.5 1.5H17a1.5 1.5 0 0 0 1.5-1.5v-2a1.5 1.5 0 0 0-.96-1.4zM16.9 12a1.7 1.7 0 1 0-3.4 0zm-.9 4a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPersonLock24);
